// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MKgc","option":"styles_option__3UTLs","active":"styles_active__1ZYPc"};